import React, { useCallback, useState } from "react"
import Typography from "@material-ui/core/Typography"
import Collapse from "@material-ui/core/Collapse"
import styles from './styles'
import clsx from 'clsx'
import minus from '~/images/icons/minus.svg'
import plus from '~/images/icons/plus.svg'
import { useMediaQuery, useTheme } from "@material-ui/core"


interface Props {
  className?: string;
  imagePath: string;
  title: string;
  content: {title: string, text: string}[];
}
 export const  CollapsedItem = ({className, title, content, imagePath}: Props) => {
  const [open, setOpen] = useState<boolean>(false);
  const toggle = useCallback(() => setOpen((oldStateOpen: boolean) => !oldStateOpen), []);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const classes = styles(open);
  return (
    <div className={clsx(classes.mainContainer, className)}>
      <div className={classes.titleBlock} onClick={toggle}>
        <Typography variant={isMobile ? 'h6' : 'subtitle2'} className={classes.title}>{title}</Typography>
        <img src={open ? minus : plus} alt="icon" className={classes.icon}/>
        <div style={{display: "none", backgroundImage: `url(${imagePath})`}}></div>
      </div>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <div className={classes.contentBlock}>
          <div className={classes.contentInfo}>
            {
              content.map(({title: itemTitle, text}) => (
                <div key={itemTitle} className={classes.contentItem}>
                    <Typography variant="subtitle1" className={classes.itemTitle}>{itemTitle}</Typography>
                    <Typography variant="body1" className={classes.itemText}>{text}</Typography>
                </div>
              ))
            }
          </div>
          <div className={classes.contentImage} style={{backgroundImage: `url(${imagePath})`}}></div>
        </div>
      </Collapse>
    </div>
  );
};
